// Modules
import React from 'react';
import cn from 'classnames';

// Types
import type { TButtonProps } from './Button.type';

// Styles
import styles from './styles/styles.module.scss';


// Constants
import { BUTTON_DEFAULT_PROPS, BUTTON_LOADING_ICON_POSITION } from './Button.constant';

const Button = (props: TButtonProps) => {
	const {
		block,
		children,
		className,
		color = BUTTON_DEFAULT_PROPS.color,
		disabled,
		isLoading,
		loadingIconPosition = BUTTON_DEFAULT_PROPS.loadingIconPosition,
		loadingText,
		size = BUTTON_DEFAULT_PROPS.size,
		variant = BUTTON_DEFAULT_PROPS.variant,
		...restProps
	} = props;

	const buttonCN = cn(styles.legion_button, className, styles[size!], styles[variant!], {
		[styles.block]: block,
		[styles.disabled]: disabled,
		[styles.loading]: isLoading,
		[styles[color!]]: !disabled,
		[styles['loading_right']]: loadingIconPosition === BUTTON_LOADING_ICON_POSITION.right
	});

	return (
		<button className={buttonCN} {...restProps}>
			{isLoading ? (
				<>
					{loadingText && (<p>{loadingText}</p>)}
				</>
			) : (
				children
			)}
		</button>
	);
}

export default Button;
